import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Why need a customised plan?",
      answer: "A tailored retirement plan ensures a future that aligns with your unique desires and necessities."
    },
    {
      question: "How do you maximise savings?",
      answer: "Through meticulous research, market trends, and effective strategies, we help amplify your savings."
    },
    {
      question: "Is tax planning crucial?",
      answer: "Indeed. Tax-efficient strategies can greatly boost your net retirement savings."
    },
    {
      question: "How often should I consult?",
      answer: "Regular consultations, preferably annually, ensure alignment with financial trends and personal changes."
    },
    {
      question: "What sets your advisory apart?",
      answer: "Our commitment to data-backed, unbiased, and custom solutions distinguishes us."
    },
    {
      question: "How flexible are your plans?",
      answer: "Extremely. We adjust strategies based on market conditions and your evolving needs."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About Retirement Planning
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our retirement planning services.
              For detailed information, our experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;